import { Grid, Typography } from "@mui/material";

import Logo from "../Logo";
import PlanProductInfo from "../PlanProductInfo";
import { styled } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const ContainerWithStyles = styled(Grid)`
  background-color: transparent;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-right: 10px;
`;
const Header = (props) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  return (
    <ContainerWithStyles
      container
      direction={matches ? "row" : "column"}
      xs={12}
    >
      {!matches && (
        <Grid item>
          <Logo />
        </Grid>
      )}
      <Grid item sx={12}>
        <Typography variant="h3">{props?.name}</Typography>
      </Grid>
      {/*Depending on page need to show book or fulfilments numbers*/}
      {props?.productShow && (
        <PlanProductInfo
          current={props?.totalNumber}
          // upgradePlan={props.upgradePlan ? true : false}
          upgradePlan={true}
          max={props?.remainingNumber}
          quantityFrom={props?.quantityFrom}
          quantityTo={props?.quantityTo}
        />
      )}
    </ContainerWithStyles>
  );
};

export default Header;
